import { Storage } from '@ionic/storage-angular';
import { APP_INITIALIZER, Provider } from '@angular/core';

export function initializeStorage(storage: Storage) {
    return async () => {
        await storage.create();
    };
}

export const provideIonicStorage: Provider = [
    Storage,
    {
        provide: APP_INITIALIZER,
        useFactory: initializeStorage,
        deps: [Storage],
        multi: true
    }
];